import {ReactNode} from "react";
import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";

interface IProps {
    children: ReactNode;
    className?: string;
}

export function ChatBotMessage(props: IProps) {
    const {children, className} = props;

    return (
        <div className={cx(messageItemStyles, className)}>
            <Text variant="info_txt_1">{children}</Text>
        </div>
    );
}

const messageItemStyles = css({
    alignSelf: "flex-start",
    background: "var(--colors-background-100)",
    overflow: "hidden",
    padding: 1,
    marginBottom: 1,
    borderRadius: 2
});
import {ReactNode} from "react";
import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";

interface IProps {
    children: ReactNode;
    className?: string;
}

export function ChatBotMessage(props: IProps) {
    const {children, className} = props;

    return (
        <div className={cx(messageItemStyles, className)}>
            <Text variant="info_txt_1">{children}</Text>
        </div>
    );
}

const messageItemStyles = css({
    alignSelf: "flex-start",
    background: "var(--colors-background-100)",
    overflow: "hidden",
    padding: 1,
    marginBottom: 1,
    borderRadius: 2
});
